export const getDefaultAreaChartXaxisLabels = (withEmptyLine?: boolean) =>
  Array.from({ length: 30 }, (_, i) => (i + 1).toString() + (withEmptyLine ? '\n' : ''));
